/**
 * Temporary entry point (Phase B1) — replaced by the Level-1 nav tab bar in
 * the later nav-refactor prompt. Lists groups the viewer is an active
 * member of and links to the (also temporary) create-group flow.
 */
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Plus, Users } from 'lucide-react'
import { groupsApi } from '@/api'
import { Avatar } from '@/components/profile/Avatar'

export function MyGroupsPage() {
  const { t } = useTranslation()
  const { data, isLoading } = useQuery({
    queryKey: ['groups', 'mine'],
    queryFn: () => groupsApi.list({ mine: true }),
  })

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid var(--border)' }}>
        <span style={{ flex: 1, fontFamily: 'var(--font-sans)', fontWeight: 700, fontSize: 'var(--fs-lg)', color: 'var(--text-strong)' }}>
          {t('groups.my_groups')}
        </span>
        <Link
          to="/groups/create"
          style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 'var(--radius-pill)', background: 'var(--brand)', color: 'var(--on-brand)', textDecoration: 'none', fontFamily: 'var(--font-sans)', fontWeight: 700, fontSize: 'var(--fs-sm)' }}
        >
          <Plus size={16} /> {t('groups.create_group')}
        </Link>
      </div>

      {isLoading ? (
        <div style={{ padding: 24, textAlign: 'center', color: 'var(--text-faint)' }}>{t('common.loading')}</div>
      ) : !data || data.items.length === 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '56px 24px', textAlign: 'center' }}>
          <Users size={40} strokeWidth={1.5} style={{ color: 'var(--text-faint)', marginBottom: 12 }} />
          <p style={{ margin: 0, fontFamily: 'var(--font-sans)', fontWeight: 600, fontSize: 'var(--fs-sm)', color: 'var(--text-strong)' }}>
            {t('groups.no_groups_yet')}
          </p>
        </div>
      ) : (
        <div>
          {data.items.map((group) => (
            <Link
              key={group.id}
              to={`/groups/${group.slug}`}
              style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: '1px solid var(--border)', textDecoration: 'none' }}
            >
              <Avatar name={group.name} avatarUrl={group.avatarUrl} accountType="group" size="md" />
              <div style={{ minWidth: 0 }}>
                <div style={{ fontFamily: 'var(--font-sans)', fontWeight: 600, fontSize: 'var(--fs-sm)', color: 'var(--text-strong)' }}>{group.name}</div>
                {group.description && (
                  <div style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--fs-xs)', color: 'var(--text-faint)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {group.description}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
